import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { subscribe } from "../lib/api";
import { toast } from "sonner";
import { track as trackEvent } from "../lib/analytics";

export default function JoinForm() {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(true);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !email.trim()) {
      toast.error("Both fields are required.");
      return;
    }
    setLoading(true);
    try {
      await subscribe({ firstName, email, marketingConsent: consent });
      setSuccess(true);
      trackEvent("newsletter_join");
    } catch (err) {
      toast.error("Transmission failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md" data-testid="join-form-wrapper">
      <AnimatePresence mode="wait">
        {success ? (
          <motion.div
            key="success"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center py-10"
            data-testid="join-success"
          >
            <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">TRANSMISSION RECEIVED</p>
            <h3 className="font-serif text-6xl md:text-7xl text-white">YOU'RE IN.</h3>
            <p className="text-white/50 text-sm mt-6">
              You will be notified as new dimensions open.
            </p>
          </motion.div>
        ) : (
          <motion.form
            key="form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="space-y-8"
            data-testid="join-form"
          >
            <div>
              <label className="font-mono text-[10px] tracking-[0.25em] text-white/40 block mb-3">FIRST NAME</label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                data-testid="join-firstname"
                className="w-full bg-transparent border-b border-white/20 focus:border-gold outline-none py-3 text-lg text-white transition-colors placeholder:text-white/20"
                placeholder="Your name"
              />
            </div>
            <div>
              <label className="font-mono text-[10px] tracking-[0.25em] text-white/40 block mb-3">EMAIL</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="join-email"
                className="w-full bg-transparent border-b border-white/20 focus:border-gold outline-none py-3 text-lg text-white transition-colors placeholder:text-white/20"
                placeholder="you@dimension.com"
              />
            </div>
            <label className="flex items-start gap-3 cursor-pointer group" data-testid="join-consent">
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                className="mt-1 accent-[#d4af37] w-4 h-4"
              />
              <span className="text-sm text-white/50 group-hover:text-white/70 transition-colors">
                Notify me about new dimensions, releases and limited editions.
              </span>
            </label>
            <button
              type="submit"
              disabled={loading}
              data-testid="join-submit"
              className="group relative overflow-hidden bg-gold text-black font-mono text-[11px] tracking-[0.25em] px-10 py-4 hover:bg-white transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? "TRANSMITTING..." : "ENTER THE INNER CIRCLE"}
            </button>
          </motion.form>
        )}
      </AnimatePresence>
    </div>
  );
}
